import {LangFilesAcceptedApi} from "@app/api";
import {IObservableArray, observable} from "mobx";
import {MLanguageFilesAccepted} from "@elte/translate-backend/interface/lang_files_accepted";
export import TRespondFind = MLanguageFilesAccepted.TResponseFind;

export class LangFilesAcceptedModel {
    private readonly api: LangFilesAcceptedApi;

    constructor() {
        this.api = new LangFilesAcceptedApi()
    }

    dataLangFilesAccepted: IObservableArray<MLanguageFilesAccepted.TResponseFind> = observable.array([],{deep:false});


    findFiles() {
        return this.api.find().then(value => {
            this.dataLangFilesAccepted.replace(value);
            return this.dataLangFilesAccepted;
        });
    }

    getSelectedToAccept(id,lang):Promise<MLanguageFilesAccepted.TResponseGet> {
        return this.api
            .get(id, {query: {lang}})
            .then((value) => {
                return {
                    main:null,
                    target: value.target,
                    fileId: value.fileId
                }
            })
     }

     saveUsersTranslation(data:MLanguageFilesAccepted.TRequestDateCreate): Promise<MLanguageFilesAccepted.TRequestDateCreate> {
        return this.api
            .create(data).then(value => {
             return value
            })
            }

            removeUsersTempFile(id, lang): Promise<MLanguageFilesAccepted.Data> {
              return this.api.remove(id, {query: {lang}})
            }

}
